import { render, staticRenderFns } from "./NewCollectionRequest.vue?vue&type=template&id=085519d9&scoped=true&"
import script from "./NewCollectionRequest.vue?vue&type=script&lang=ts&"
export * from "./NewCollectionRequest.vue?vue&type=script&lang=ts&"
import style0 from "./NewCollectionRequest.vue?vue&type=style&index=0&id=085519d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085519d9",
  null
  
)

export default component.exports